<template>
  <v-app>
    <v-card tile color="transparent">
      <vrow class="m-3"><back-button></back-button></vrow>

      <v-row class="m-3" v-if="data != null" :loading="loading">

        <v-flex class="m-3" sm="12" md="6">
          <div v-if="data.user_info != null">
            <request-details :request="data"/>
          </div>
          <div v-if="data.bussiness != null">
            <business :request="data"/>
          </div>
          <div v-if="data.bussiness == null && data.user_info == null">
            <p class="text-center text-dark-50 mt-20 h3"> کاربر هنوز پروفایل خود را تکمیل نکرده است.</p>
          </div>
        </v-flex>

        <v-flex class="m-3" sm="12" md="6">
          <user-details :details="data"/>
        </v-flex>

      </v-row>

      <v-row class="mt-3 p-4">
        <div class="container-fluid">

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <v-container fluid>
                  <v-card-title>
                    <!--                                    v-if="$can('transaction_create')"-->

                    <v-spacer/>
                    تراکنش های کاربر
                    <v-spacer/>


                  </v-card-title>
                  <v-divider/>

                  <div class="row">

                    <div class="col-md-12 p-5">

                      <data-table
                          :data="transactions"
                          :columns="columnTransactions"
                          :translate="translate"
                          :per-page="[10, 25, 50, 100]"
                          @on-table-props-changed="reloadTable">
                      </data-table>
                    </div>
                  </div>

                </v-container>
              </div>
            </div>
          </div>
        </div>

      </v-row>
      <hr>
      <v-row class=" p-4 mt-3 mb-3">

        <div class="container-fluid">

          <div class="row">
            <div class="col-md-12">

              <user-jobs :packs="data.packs"></user-jobs>
            </div>
          </div>
        </div>
      </v-row>

    </v-card>

  </v-app>
</template>

<script>
import RequestDetails from "@/view/pages/admin/confirm/userInfo/requestDetails";
import Business from "@/view/pages/admin/confirm/userInfo/Business";
import UserDetails from "@/view/pages/admin/confirm/userInfo/userDetails";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import UserJobs from "@/view/pages/admin/users/actions/userJobs";

export default {
  name: "Information",
  components: {UserJobs, UserDetails, Business, RequestDetails},
  props: ['id'],
  data() {
    return {
      data: [],
      user: {},
      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      url: 'authRequest',
      userInfo: {},
      transactions: {},
      packs: {},
      transactionUrl: 'userTransaction',
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      loading: false,

      columnTransactions: [
        {
          name: 'uuid',
          label: 'شناسه پرداخت',
          orderable: true,

        },
        {
          name: 'amount',
          label: 'قیمت(﷼)',
          orderable: true,
          transform: (value) => {
            return this.$options.filters.rial(value.data.amount);
          },
        },
        {
          name: 'type',
          label: 'نوع',
          transform: (value) => {
            return value.data.type === 'deposit'
                ? `<span class="badge-pill badge badge-success">افزایش موجودی</span>`
                : `<span class="badge-pill badge badge-danger">کسر موجودی</span>`
          }
        },
        {
          name: 'confirmed',
          label: 'وضعیت',
          transform: (value) => {
            return value.data.confirmed === true
                ? `<span class="badge-pill badge badge-info">تایید شده</span>`
                : `<span class="badge-pill badge badge-danger">تایید نشده</span>`
          }

        },

      ],
    }
  },
  created() {
    this.getUserInfo();
    this.getUserTransactions(this.transactionUrl);
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
  },

  methods: {
    getUserInfo() {
      this.loading = true;
      this.requestApiGet('user/' + this.id).then(({data}) => {
        this.data = data;
        this.user = data;
        tableProps
        this.loading = false;
      });
    },
    getUserTransactions(url = this.transactionUrl, params = this.tableProps) {
      this.loading = true;
      this.requestApiGet(`${url}/${this.id}`, params).then(response => {
        this.transactions = response.data;
        this.loading = false;
      });
    },
    reloadTable(tableProps) {
      this.getUserTransactions(this.transactionUrl, tableProps);
    },

  },

}
</script>

<style scoped>

</style>